// @ts-nocheck
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { CmsLibraryModel } from "@store/Framework/Types/ApiModels";

const cmsLibraryUrl = "api/v1/cmslibrary/assets";

export interface GetCmsLibraryApiParameter extends ApiParameter {
    libraryType: string;
    search?: string;
    assetFolderId?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    isFirstLoad?: boolean;
}

export async function getCmsLibrary(parameter: GetCmsLibraryApiParameter) {
    const { libraryType, ...apiParameter } = parameter;
    delete apiParameter.isFirstLoad;
    const cmsLibrary = await get<CmsLibraryModel>(`${cmsLibraryUrl}/${libraryType}`, apiParameter);
    return cmsLibrary;
}
